import { Modal } from '@/components/Modal';
import { Link } from '@/types/link';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconDetailView } from './IconDetailView';
import { IconSelectionView } from './IconSelectionView';

interface CreateCardLinkProps {
  isOpen: boolean;
  onClose: () => void;
  links: Link[];
}

export const CreateCardLink = ({
  isOpen,
  onClose,
  links,
}: CreateCardLinkProps) => {
  const { t } = useTranslation();
  const [selectedLink, setSelectedLink] = useState<Link | null>(null);

  const handleLinkSelect = (link: Link) => {
    setSelectedLink(link);
  };

  const handleBackToLinkSelection = () => {
    setSelectedLink(null);
  };

  const handleClose = () => {
    setSelectedLink(null);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      className={selectedLink ? 'max-w-xl' : 'max-w-3xl'}
      title={selectedLink ? undefined : t('updateCard:links.create')}
    >
      {selectedLink ? (
        <IconDetailView
          link={selectedLink}
          onBack={handleBackToLinkSelection}
          onClose={handleClose}
        />
      ) : (
        <IconSelectionView
          links={links}
          selectedLink={selectedLink}
          onLinkSelect={handleLinkSelect}
        />
      )}
    </Modal>
  );
};
